import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Detect appellations mentioned in a body of text (article, AI output, blog…)
 * and return the list ready to feed <AppellationInsight/> cards. Uses the
 * public endpoint POST /api/chat/detect-appellations. Result is cached in-memory
 * per exact-text key to avoid re-calling on re-renders.
 */
const _cache = new Map();

export function useAppellations(text) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const key = (text || "").trim();
    if (!key || key.length < 8) { setItems([]); return; }
    if (_cache.has(key)) { setItems(_cache.get(key)); return; }
    let cancelled = false;
    api.post("/chat/detect-appellations", { text: key })
      .then((r) => {
        const arr = r.data?.appellations || [];
        _cache.set(key, arr);
        if (!cancelled) setItems(arr);
      })
      .catch(() => { if (!cancelled) setItems([]); });
    return () => { cancelled = true; };
  }, [text]);

  return items;
}
